export const athleticsKeys = [
  'football',
  'hockey',
  'soccer',
  'volleyball',
  'baseball',
  'basketball',
  'crossCountry',
  'golf',
  'lacrosse',
  'swimming',
  'tennis',
  'fieldHockey',
  'trackAndField',
  'wrestling',
  'gymnastics',
  'softball',
  'cheer',
  'dance',
]
export const artsKeys = ['theatre', 'choir', 'band', 'marchingBand', 'orchestra', 'drama', 'visualArts']
export const educationalKeys = [
  'spedSignificantSupportNeeds',
  'careerTechnicalEducation',
  'collegeCareerAdvising',
  'emotionalDisabilityPrograms',
  'englishAsSecondLanguage',
  'communicationSocialDelay',
  'ruler',
  'emotionalInteligence',
  'sourcesOfStrength',
  'pbl',
  'ibPyp',
  'ibMyp',
  'ibDp',
  'ibCp',
  'deca',
  'stem',
  'steam',
  'silt',
  'tag',
  'avid',
  'ap',
  'honors',
  'artsAcademy',
  'immersion',
  'byod',
  'oneToOne',
  'emotionalIntelligence',
  'childCare',
  'collegePathways',
  'mtss',
  'highTrails',
  'preschool',
  'pltw',
  'biliteracy',
  'nsoe',
]
